const CreditNoteTotals = ({ form }: { form: any }) => {
    const subtotal = form.taxableSubtotal || 0;
    const perceivedIVA = form.perceivedIVA || 0;
    const totalToRefund = form.totalToRefund || 0;
  
    return (
      <div className="w-full max-w-md space-y-4 text-sm uppercase">
        <p className="flex justify-between text-gray-700 dark:text-gray-300 font-medium">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </p>
        <p className="flex justify-between text-gray-700 dark:text-gray-300 font-medium">
          <span>IVA Percibido</span>
          <span>${perceivedIVA.toFixed(2)}</span>
        </p>
        <p className="flex justify-between border-t pt-4 font-semibold text-gray-900 dark:text-white dark:border-strokedark">
          <span>Total a Devolver</span>
          <span>${totalToRefund.toFixed(2)}</span>
        </p>
      </div>
    );
  };
  
  export default CreditNoteTotals;
  